import React from 'react'
// Components
import Welcome from './center/Welcome'
import About from './center/About'
import Experience from './center/Experience'
import Projects from './center/Projects'
import Contact from './center/Contact'

function CenterContent() { 
	return (
	<div className="Panel-center">
		{/* ==== Welcome Section ==== */}
		<Welcome/>
		{/* ==== ABOUT SECTION ==== */}
		<About/>
		<br/>
		{/* ==== EXPERIENCE SECTION ==== */}
		<Experience/>
		<br/><br/><br/>
		{/* ==== PROJECT SECTION ==== */}
		<Projects/>
		{/* ==== Contact SECTION ==== */}
		<Contact/>
		<p>Created by Joseph A Guzzardo with React, CSS, HTML & Netlify.</p>
	</div>
	)
}

export default CenterContent